import React, { useEffect, useRef } from "react";

function Test() {


  return (
    <div
      // className="w-[100vw] overflow-scroll"
    >
      <div className="h-[500px] bg-red-400">div 1</div>
      <div className="h-[500px] bg-green-400">div 2</div>
      <div className="h-[500px] bg-blue-400">div 3</div>
    </div>
  );
}

export default Test;
